import React from "react";
import Indusone from "../../images/Product/oil-gas-platform-2_pi.jpg";

function OurExpertise() {
  return (
    <div className="w-full">
      {/* Top Section - Image & Text */}
      <div className="mx-auto md:mt-3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4 text-center">
            PRODUCTION DIVISION
            </h2>
            <p className="text-sm md:text-lg mb-6 text-justify">
            As a premier global high-performance silicones and specialties company, Momentive creates solutions that improve quality of life for people and enable a more sustainable future. Our products are the result of a tireless pursuit of progress where the sun never sets on our global marketing and R&D efforts, resulting in innovations that help propel our customers’ businesses forward and positively impact all aspects of life – today, tomorrow, and into the future.
We collaborate closely with industry leaders to tailor solutions that meet evolving market demands.
With a commitment to excellence, we turn bold ideas into breakthrough technologies that shape a better world.
            </p>
          </div>


          {/* Right Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurExpertise;

